module.exports = __webpack_public_path__ + "img/3.969c7d63.png";